import React from "react";
import { FiBattery } from "react-icons/fi";
import { Card, Table } from "react-bootstrap";
import withRouter from "../../util/WithRouter";

class LocationTable extends React.Component {
  // Helper to determine WCAG-compliant contrast colors
  getBatteryStyle(battery) {
    if (battery >= 70) return { bg: "bg-success", text: "text-white" };
    if (battery >= 40) return { bg: "bg-warning", text: "text-dark" }; // Dark text for WCAG compliance
    return { bg: "bg-danger", text: "text-white" };
  }

  render() {
    const { data } = this.props;
    return (
      <Card className="h-100 shadow-sm border-0">
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0 fw-semibold">Location History</h5>
            <span className="text-muted small" aria-live="polite">{data.length} records</span>
          </div>

          <div style={{ maxHeight: "65vh", overflowY: "auto" }} tabIndex="0" aria-label="Location history table">
            <Table bordered hover responsive className="align-middle mb-0">
              <thead className="table-light sticky-top" style={{ zIndex: 1 }}>
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col">Time</th>
                  <th scope="col">Address</th>
                  <th scope="col" className="text-center">Battery</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center py-5 text-muted">
                      No records found for the selected filters
                    </td>
                  </tr>
                ) : (
                  data.map((location) => {
                    const { bg, text } = this.getBatteryStyle(location.battery);
                    return (
                      <tr key={location.id}>
                        <td className="fw-semibold">{location.date}</td>
                        <td>{location.time}</td>
                        <td className="text-muted">{location.address}</td>
                        <td className="text-center">
                          <div
                            className={`d-inline-flex align-items-center justify-content-center gap-2 px-3 py-1 rounded-pill ${bg} ${text}`}
                            style={{
                              fontWeight: 600,
                              boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                              minWidth: "90px",
                            }}
                            aria-label={`Battery level ${location.battery}%`}
                          >
                            <FiBattery size={16} aria-hidden="true" />
                            {location.battery}%
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    );
  }
}

export default withRouter(LocationTable);